import { ONE_LINK_BASE_URL } from "../../../../../../../constants";

const generateOneLinkURL = (webContext, productId) => {
  const affId = webContext.affiliateId
    ? `&affid=${webContext.affiliateId}`
    : "";
  const customerRef = webContext.customerId
    ? `&custref=${webContext.customerId}`
    : "";

  const queryParams = new URLSearchParams({
    pid: "qr_code",
    c: "eap-app-adoption",
    deep_link_value: `asos://prd?iid=${productId}channelref=eap-app-adoption${affId}${customerRef}`
  });

  return `${ONE_LINK_BASE_URL}?${queryParams.toString()}`;
};

export default generateOneLinkURL;
